import type { AxiosRequestConfig } from 'axios'

import { TAG_TYPES } from '@lib/config'

import { getUserCart } from '~/lib/services/api/cart'

export interface UseGetCartParams {
  location?: string
  country?: string
  island?: string
  axiosConfig?: AxiosRequestConfig
}

export function getCartQueryConfig(params?: UseGetCartParams) {
  const { location, country, island, axiosConfig } = params || {}

  return {
    queryFn: async () => {
      const res = await getUserCart(location, country, island, axiosConfig)
      return res.data.data
    },
    queryKey: [TAG_TYPES.CART, location, country, island],
    refetchOnWindowFocus: true,
  } as const
}
